"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _moment = _interopRequireDefault(require("@package/moment"));

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function Dates(_ref) {
  var creationDate = _ref.creationDate;

  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper'],
      "data-locator": "payout.creation-date"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      "data-locator": "payout.creation-date.date"
    }, (0, _moment["default"])(creationDate).format('DD.MM.YY'))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['row']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment',
      "data-locator": "payout.creation-date.time"
    }, (0, _moment["default"])(creationDate).format('HH:mm'))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = /*#__PURE__*/_react["default"].memo(Dates);

exports["default"] = _default;